module.exports = __webpack_public_path__ + "static/media/goForward.bfc0521d.mp3";